/** ドキュメントに登録できる画像ファイルの拡張子（大文字小文字は問わない） */
const IMAGE_FILE_EXTENSIONS = ['.jpg', '.jpeg', '.png'] as const;

export default class FileUtil {
  /**
   * 画像ファイルのパス（またはファイル名）かどうか
   * URLで渡ることがあるため、クエリ・フラグメントは除いて判定する
   */
  public static isImageFile(path: string): boolean {
    if (!path) return false;
    const lowerPath = path.toLowerCase().split(/[?#]/)[0];
    return IMAGE_FILE_EXTENSIONS.some((extension) => lowerPath.endsWith(extension));
  }
}
